import {NodeType} from 'common/src/modules/nodes/nodes.types';
import {CLStore} from 'common/src/redux/store';
import {optimizationCardSchema} from '../../schemas/optimizationCardSchema';
import addOrUpdateCardTool from '../general/addOrUpdateCardTool/addOrUpdateCardTool';

export default function addOrUpdateOptimizationCardTool(store: CLStore) {
  return addOrUpdateCardTool({
    store,
    cardType: NodeType.GENERAL_OPTIMIZATION,
    cardSchema: optimizationCardSchema,
  });
}
